import type { RouteLocationGeneric, RouteRecordRaw } from "vue-router"
import { useAuthStore } from "@core/stores/auth.store"
import PageBuildingMeter from "@core/pages/building/PageBuildingMeter.vue"
import PageBuildingSensorList from "@core/pages/building/PageBuildingSensorList.vue"
import PageBuildingWeatherStation from "@core/pages/building/PageBuildingWeatherStation.vue"
import PageBuildingPartage from "@core/pages/building/PageBuildingAccess.vue"
import PageBuildingInfoGeneral from "@core/pages/building/PageBuildingInfoGeneral.vue"

export const buildingShellMeta = {
    requiresAuth: true,
    layout: "header-sidebar",
    sidebar: "building",
} as const

export async function ensureAuthUserLoaded(
    authStore: ReturnType<typeof useAuthStore>
): Promise<void> {
    if (authStore.isLogged && !authStore.userId) {
        await authStore.fetchUser()
    }
}

/**
 * Redirection par défaut de la fiche bâtiment (reste en premier dans l’arbre des enfants).
 */
export const coreBuildingShellChildrenHead = [
    {
        path: "",
        redirect: (to: RouteLocationGeneric) => ({
            name: "PageBuildingData",
            params: {
                _id_building: String(to.params._id_building),
            },
        }),
    },
] as RouteRecordRaw[]

/**
 * Routes cœur après la route « data » du module `data` (`modules/data/building.routes.ts`).
 */
export const coreBuildingShellChildrenTail = [
    {
        path: "compteur",
        name: "PageBuildingMeter",
        component: PageBuildingMeter,
    },
    {
        path: "partage",
        name: "PageBuildingPartage",
        component: PageBuildingPartage,
    },
    {
        path: "objet-connecte",
        name: "PageBuildingSensorList",
        component: PageBuildingSensorList,
    },
    {
        path: "station-meteo",
        name: "PageBuildingWeatherStation",
        component: PageBuildingWeatherStation,
    },
    {
        path: "info-general",
        name: "PageBuildingInfoGeneral",
        component: PageBuildingInfoGeneral,
    },
] as RouteRecordRaw[]
